import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';
import media from 'src/styles/Media.styled';

export const CarouselContainer = styled.div`
    height: ${(props) => props.height};
    width: ${(props) => props.width};
    display: flex;
    justify-content: ${(props) => props.justifyContent};
    margin-left: ${(props) => props.marginLeft};
    position: relative;
`;

export const StyledCarousel = styled(Carousel)`
& .control-dots {
    bottom: -50px;
   }
  & .slider-wrapper {
            & .slider {
                & .slide {
                    padding: ${(props) => props.padding || '10px'};
                }
            }
        }
        ${media.mobileDevice`
            & .slider-wrapper {
            clip-path: inset(0 0 0 0);
            position: relative;
        }
        .slider-wrapper.axis-horizontal > ul {
            top: 0;
            height: auto;
            flex-direction:row;
            justify-direction: flex-start;
            opacity: 1;
            z-index: auto;
        }
            .carousel.carousel-slider {
            width:104% !important;
            }
        `}
 width :100%;
`;

export const DotContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: ${(props) => props.marginTop || '10px'};
    margin-bottom: ${(props) => props.marginBottom};
`;

export const Dot = styled.div`
    width: 12px;
    height: 12px;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    margin: 0 5px;
    cursor: pointer;

    &.active {
        background-color: #170f5f;
    }
`;

export const ArrowContainer = styled.div`
    width: 30px;
    height: 30px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: ${(props) => props.position};
    background-color: #fff;
    border: 1px solid #ebebeb;
    box-shadow: 0 0 2px #00000029;
    align-self: center;
    opacity: 1;
    transform: ${(props) => props.position === 'fixed' ? 'translateZ(0)' : 'none'};
    z-index: ${(props) => props.position === 'absolute' ? 9999999 : 'auto'};
    box-sizing: border-box;
    cursor: pointer;
`;
export const BlueArrowPrevButton = styled.button`
    position: ${({ isMobile }) => (isMobile ? 'absolute' : 'relative')};
    z-index: 1;
    margin-left: 0px;
    margin-top: ${({ isMobile }) => (isMobile ? '14vh' : 'unset')};
    background-color: transparent;
    border: none;
    box-sizing: border-box;
    visibility: ${({ hasPrev }) => (hasPrev ? 'visible' : 'hidden')};
`;

export const BlueArrowNextButton = styled.button`
    position: ${({ isMobile }) => (isMobile ? 'absolute' : 'relative')};
    z-index: 1;
    margin-left: ${({ viewLarger, centerMode, isMobile }) =>
        viewLarger
            ? '10px'
            : centerMode
            ? '5px'
            : isMobile
            ? '83vw'
            : '0px'};
    margin-top: ${({ isMobile }) => (isMobile ? '14vh' : 'unset')};
    background-color: transparent;
    border: none;
    box-sizing: border-box;
    visibility: ${({ hasNext }) => (hasNext ? 'visible' : 'hidden')};
`;

export const ArrowImg = styled.img`
   // margin-top: 4px;
    box-sizing: border-box;
    width: unset;
`;
export const SingleImageContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: ${({ viewLarger, isMobile }) =>
        viewLarger ? '30px' : isMobile ? '10px' : '0px'};
`;

export const SingleImage = styled.img`
    object-fit: contain !important;
    ${({ isMobile, viewLarger }) => (isMobile || viewLarger) && 'max-width: 100%;'}
    margin-top: ${({ viewLarger }) => (viewLarger ? '14px' : '0px')};
    border: 1px solid rgba(0, 0, 0, 0.3) !important;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.1);
    cursor: ${({ centerMode }) => (centerMode ? 'pointer' : 'default')};
    border-radius: ${({ isCondensedView }) => (isCondensedView ? '6px' : '0px')};
    object-fit: contain;
`;
export const CarouselImage = styled.img`
    width: 100%;
    max-height: 250px;
    object-fit: contain !important;
    border: 1px solid rgba(0, 0, 0, 0.3) !important;
    box-sizing: border-box ;
    display: block ;
    cursor: ${({ centerMode }) => (centerMode ? 'pointer' : 'default')};
`;

export const ImageDisplayFlex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;